import axios from "axios";

import { attachAcceptLanguage } from "src/api/interceptors/attach-accept-language";
import { attachAccessToken } from "src/api/interceptors/attach-access-token";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { refreshAccessTokenLogic } from "src/api/interceptors/refresh-access-token-logic";
import { attachSiteToken } from "src/features/site/api/interceptors/attach-site-token";

const securityApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/security-view-api/v4`,
});

createAuthRefreshInterceptor(securityApi, refreshAccessTokenLogic);

securityApi.interceptors.request.use(attachAccessToken);
securityApi.interceptors.request.use(attachSiteToken);
securityApi.interceptors.request.use(attachAcceptLanguage);

export default securityApi;
